import { SiteTextsStore } from "@Front/Stores/SiteTextsStore";
import { LoggerService } from "@Front/Services/LoggerService/LoggerService";
import { loadPublicConfigRuntime } from "@Front/Config/ConfigRuntime";

export async function preloadSiteTextsForLocale(
	locale: string,
	normalizedScopes: string[],
	normalizedTextKeys: string[],
): Promise<void> {
	await SiteTextsStore.instance.preload({
		locale,
		scopes: normalizedScopes.length ? normalizedScopes : undefined,
		textKeys: normalizedTextKeys.length ? normalizedTextKeys : undefined,
	});
}

export async function runSiteTextsPreloadAttempt(
	locale: string,
	normalizedScopes: string[],
	normalizedTextKeys: string[],
): Promise<{ success: true } | { success: false; error: Error }> {
	try {
		await preloadSiteTextsForLocale(locale, normalizedScopes, normalizedTextKeys);
		return { success: true };
	} catch (err) {
		const failure = err instanceof Error ? err : new Error("Unknown site text preload failure");
		LoggerService.error("❌ [SiteTextsProvider] Failed to preload texts", {
			error: failure.message,
			locale,
			scopes: normalizedScopes,
			textKeys: normalizedTextKeys,
		});
		return { success: false, error: failure };
	} finally {
		void loadPublicConfigRuntime();
	}
}
